import React, { lazy } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useStore from "../../store";

const importDialog = (component) => React.lazy(() => import("../../Dialogs/" + component + "/" + component)); // eslint-disable-line

const importPluginDialog = (plugin, component) => lazy(() => new Promise((resolve) => {
    import("../../Plugins/" + plugin + "/Dialog/" + component).then((componentPlugin) => { // eslint-disable-line
        resolve(componentPlugin);
    }).catch(() => {
        import("../../Widgets/ComponentNotFound/ComponentNotFound").then((notFound) => {
            resolve(notFound);
        });
    });
})); export default function Dialog() {
    const dialog = useStore((store) => store.dashboard.dialog);
    const [view, setView] = React.useState([]);
    React.useEffect(() => {
        if (dialog) {
            (async () => {
                if (!dialog.plugin) {
                    const ImportedDialog = await importDialog(dialog.component);
                    setView(<ImportedDialog dialog={dialog} />);
                } else {
                    const ImportedDialog = await importPluginDialog(dialog.plugin[0].toUpperCase() + dialog.plugin.slice(1), dialog.component);
                    setView(<ImportedDialog dialog={dialog} />);
                }
            })();
        } else {
            setView([]);
        }
    }, [dialog]);
    return (
        view.length !== 0 && (
            <React.Suspense fallback={(
                <FontAwesomeIcon
                    mt={6}
                    ml={2}
                    mr={2}
                    icon="spinner"
                    spin
                />
            )}
            >
                {view}
            </React.Suspense>
        )
    );
}
